import { isTempClipId } from '@src/services/WriteQueueService';

import type { OtherVideo } from '@src/types.ts/story';

/**
 * Whether a clip card can be picked in the Content Studio clip grid at all
 * (PLAT-11118).
 *
 * Deliberately weaker than `isClipCombinable`: that one answers "can this
 * become a reel Section", which is the wrong question for a group Delete. An
 * uploaded or imported video has no source range to crop from, but it is
 * exactly the kind of thing a creator wants to sweep out of a story.
 *
 * A clip still being written stays out of both — there is no persisted record
 * to delete or to crop from.
 */
export function isClipSelectable(clip: OtherVideo): boolean {
  return !!clip.id && !isTempClipId(clip.id);
}
